const KEY = 'tenantBranding';
/**
 * Obviously-placeholder defaults shown until the tenant sets up branding in
 * Settings → Branding. Deliberately generic ("ABC Company") so no tenant ever
 * sends a customer a document carrying another company's real details.
 */
const DEFAULT_BRANDING = {
  companyName: 'ABC Company',
  logoUrl: '',
  primaryColor: '#3B82F6',
  secondaryColor: '#0F172A',
  accentColor: '#06B6D4',
  neutralColor: '#475569',
  headerHtml: '<strong>ABC Company</strong>',
  headerTagline: 'Your company tagline here',
  footerHtml: '',
  supportEmail: 'support@example.com',
  supportPhone: 'Ph : 000-000-0000',
  addressBlock: 'XYZ Address, Street 1, Your City - 000000.',
  footerWebsite: 'www.example.com',
  footerTagline: 'Set up your branding in Settings',
  footerServicesPreset: 'custom',
  headOfficeCity: '',
  footerServicesText: [
    'Household Relocation',
    'Office Relocation',
    'Storage Services',
  ].join('\n'),
};

/** True once the tenant has saved real branding (company name or logo). */
export function isBrandingConfigured(branding) {
  const b = branding || readTenantBranding();
  const name = String(b.companyName || '').trim();
  const hasRealName = name && name !== DEFAULT_BRANDING.companyName;
  const hasLogo = !!String(b.logoUrl || '').trim();
  return hasRealName || hasLogo;
}

export function readTenantBranding() {
  try {
    const raw = localStorage.getItem(KEY);
    const parsed = raw ? JSON.parse(raw) : {};
    return { ...DEFAULT_BRANDING, ...(parsed || {}) };
  } catch (_) {
    return { ...DEFAULT_BRANDING };
  }
}

export function storeTenantBranding(branding) {
  if (!branding || typeof branding !== 'object') return;
  try {
    localStorage.setItem(KEY, JSON.stringify({ ...DEFAULT_BRANDING, ...branding }));
  } catch (_) {
    /* ignore */
  }
}

/** Merge API/caller overrides with cached branding for PDF generation. */
export function brandingForPdf(override) {
  const cached = readTenantBranding();
  if (!override || typeof override !== 'object') return cached;
  return { ...cached, ...override };
}
